module.exports = __webpack_public_path__ + "static/media/collage2_2.1a7d062e.png";